'use client';

import styles from './styles/CourseContentLayout.module.css';

export default function CourseContentLayout({ leftContent, sidebar }) {
  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        {leftContent}
      </div>
      <div className={styles.sidebar}>
        {sidebar}
      </div>
    </div>
  );
}